import { components } from '@convergence/client';

type Role = NonNullable<
  components['schemas']['MeResponse']['user']
>['roles'][0];

export function hasRole(roles: Role[], requiredRole: Role): boolean {
  return !!roles.find((role) => role === requiredRole);
}
